function dateFormat(new_date) {
    const d = new Date(new_date);
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

    return `${da}.${mo}.${ye}`;
}

function dateFormatHMS(new_date) {
    const d = new Date(new_date);
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    const ho = new Intl.DateTimeFormat('en', {
        hour: 'numeric',
        hour12: false,
    }).format(d);
    const mi = new Intl.DateTimeFormat('en', { minute: 'numeric' }).format(d);
    const se = new Intl.DateTimeFormat('en', { second: 'numeric' }).format(d);

    return `${da}.${mo}.${ye}  ${ho}:${mi}:${se}`;
}

function runningTime(new_date) {
    const d = new Date(new_date);
    const time_now = new Date();
    return dhm(time_now - d);
}

function dhm(t) {
    let cd = 24 * 60 * 60 * 1000,
        ch = 60 * 60 * 1000,
        d = Math.floor(t / cd),
        h = Math.floor((t - d * cd) / ch),
        m = Math.round((t - d * cd - h * ch) / 60000),
        pad = function(n) {
            return n < 10 ? '0' + n : n;
        };
    if (m === 60) {
        h++;
        m = 0;
    }
    if (h === 24) {
        d++;
        h = 0;
    }
    // return [d, pad(h), pad(m)].join(':');
    return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
}

export { dateFormat, dateFormatHMS, runningTime };
